import api, { API } from "./api";

/** Trigger a PDF download for a ticket via the backend, using current Bearer token. */
export async function downloadTicketPdf(ticketId, serial) {
  try {
    const res = await api.get(`/tickets/${ticketId}/pdf`, { responseType: "blob" });
    const blob = new Blob([res.data], { type: "application/pdf" });
    const url = URL.createObjectURL(blob);
    const a = document.createElement("a");
    a.href = url;
    a.download = `ticketup-${serial || ticketId.slice(0, 8)}.pdf`;
    document.body.appendChild(a);
    a.click();
    a.remove();
    setTimeout(() => URL.revokeObjectURL(url), 1000);
    return true;
  } catch (e) {
    console.error("PDF download failed", e);
    return false;
  }
}

/** Open the PDF in a new tab using the ?token= query param fallback. */
export function openTicketPdfInNewTab(ticketId) {
  const token = localStorage.getItem("ticketup_token") || "";
  const url = `${API}/tickets/${ticketId}/pdf?token=${encodeURIComponent(token)}`;
  window.open(url, "_blank", "noopener");
}
